import React from "react";
import {Box, Grid} from "@mui/material";
import {MessengerActions} from "./MessengerActions";


export function MessengerBody() {
	return (
		<Box sx={{flexGrow: 1}}>
			<div className={'section'}>
				<div className={'section-title text-left'}>
					<span className={'label'}/>
					<div className={'divider primary'}/>
				</div>
			</div>
			<div className={''}>
				<Grid container spacing={2}>
					<Grid item xs={12} xl={9}>
						Messenger Body
					</Grid>

					<Grid item xs={12} xl={3} className={'reports'}>
						<MessengerActions/>
					</Grid>

				</Grid>
			</div>
		</Box>
	)
}
